import BaseHttpService from "../baseService";

class PricingServiceProvider extends BaseHttpService {
	constructor() {
		super("pricing");
	}

	/**
	 * Current assets price
	 *
	 * @async
	 * @version 1.0.0
	 */
	public assetsPrice(): HttpService.BaseResponse<Account.AccountAsset> {
		return this.getResource().get("current-asset-prices");
	}

	/**
	 * Current price
	 *
	 * @async
	 * @version 1.0.0
	 */
	public price(day: number): HttpService.BaseResponse<Stock.PriceChart> {
		return this.getResource().get(`price/${day}`);
	}
}

const PricingService = new PricingServiceProvider();

export default PricingService;
